import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { Heading } from '../../Common/Heading';
import { getOperation } from '../../../helpers/operation';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import {
  Selector,
  SelectorItem,
  SelectorImageItem,
} from '../../Common/Selector';
import { SectionContent } from './SectionContent';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { getBaseProductType } from '../../../helpers/getBaseProductType';

type OnClick = (
  operation: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (operation, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      operation,
    },
  });

export const Operation = () => {
  const [state, send] = useService(productBuilderMachine);
  const { operation } = state.context.custom;
  const productType = getBaseProductType(state.context);

  const operationOptions = getOperation(state.context);

  if (isCurrentState('operation', state) && operationOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Tilt Control</Heading>
      <Selector isSlider={true}>
        {operationOptions.map(option => {
          const isSelected = option === operation;
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'operation',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={isSelected}
              onClick={onClick(option, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
